// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1SnDa","inputWrap":"Table_inputWrap__3Ebx6","col":"Table_col__172qD","bmiTooltip":"Table_bmiTooltip__QnNyP"};